import { Company } from 'API';
import { createContext } from 'react';
import { Updater } from 'use-immer';

export const CompanyContext = createContext<
[
  Company | null,
  Updater<Company | null>,
  Company | null,
  Updater<Company | null>,
  boolean?, // Dictates whether edits should reset with every mutation
]
>([
  null,
  () => { },
  null,
  () => { },
  false,
]);

export default CompanyContext;
